import { Injectable, SimpleChanges } from '@angular/core';
import { AssetListFilterOptionsService } from './asset-list-filter-options.service';
import { AssetListReleaseDateService } from './asset-list-release-date.service';
import { STATUS_OPTIONS } from '../constants/asset-list-actions.constants';
import { AssetListFilterOptionsState, AssetListReleaseDateState } from '../interfaces/asset-list-actions.interfaces';

@Injectable({
  providedIn: 'root',
})
export class AssetListComponentInitializationService {
  constructor(
    private readonly filterOptionsService: AssetListFilterOptionsService,
    private readonly releaseDateService: AssetListReleaseDateService
  ) {}

  public initializeFilterOptions(assets: any[], affectedAssets: any): AssetListFilterOptionsState {
    return {
      focusOptions: this.filterOptionsService.updateFocusOptions(assets),
      typeOptions: this.filterOptionsService.updateTypeOptions(assets),
      betsOptions: this.filterOptionsService.updateBetsOptions(assets),
      durationOptions: this.filterOptionsService.updateDurationOptions(assets),
      formatOptions: this.filterOptionsService.updateFormatOptions(assets),
      filterStatusOptions: this.filterOptionsService.updateStatusOptions(assets, affectedAssets, STATUS_OPTIONS),
      releaseDateState: this.releaseDateService.updateReleaseDateOptions(assets),
    };
  }

  public handleAssetsChange(
    changes: SimpleChanges,
    enableFieldsFilter: boolean,
    assets: any[],
    affectedAssets: any,
    onUpdate: (state: AssetListFilterOptionsState) => void
  ): void {
    if (changes['assets'] && enableFieldsFilter) {
      const state: AssetListFilterOptionsState = this.initializeFilterOptions(assets, affectedAssets);
      onUpdate(state);
    }

    if (changes.affectedAssets && affectedAssets) {
      const filterStatusOptions: { value: string; label: string; color: string }[] =
        this.filterOptionsService.updateStatusOptions(assets, affectedAssets, STATUS_OPTIONS);
      onUpdate({
        focusOptions: [],
        typeOptions: [],
        betsOptions: [],
        durationOptions: [],
        formatOptions: [],
        filterStatusOptions,
        releaseDateState: {
          availableYears: [],
          availableMonthsPerYear: {},
          allAssetReleaseDates: [],
          releaseMonthYear: {},
          monthCollapse: {},
          yearSelected: [],
          years: [],
          months: [],
          allReleaseSelected: false,
        },
      });
    }
  }

  public initializeReleaseDates(
    selectedReleaseDateValues: string[],
    releaseDateState: AssetListReleaseDateState,
    onUpdate: (state: AssetListReleaseDateState, selectedValues: string[]) => void
  ): void {
    if (selectedReleaseDateValues?.length) {
      const updatedState: AssetListReleaseDateState = this.releaseDateService.preSelectReleaseDates(
        selectedReleaseDateValues,
        releaseDateState
      );
      const selectedValues: string[] = this.releaseDateService.generateReleaseDateValues(updatedState);
      onUpdate(updatedState, selectedValues);
    }
  }
}
